"use strict";
window.addEventListener('load', function () {
    const agegate = document.getElementById('agv2');
    const pageWrapper = document.getElementById('page-wrapper');
    if (agegate) {
        pageWrapper === null || pageWrapper === void 0 ? void 0 : pageWrapper.classList.add('hidden');
        const mytimeout = setTimeout(() => {
            agegate.style.opacity = '1';
            clearTimeout(mytimeout);
        }, 200);
    }
    else {
        let mytimeout = setTimeout(() => {
            pageWrapper && (pageWrapper.style.opacity = '1');
            clearTimeout(mytimeout);
        }, 200);
    }
});
